import { styles as l } from "./styles.js";
const m = (e) => e.charAt(0).toUpperCase() + e.slice(1), C = (e) => {
  const o = e.depth, n = e.groupingColumnId || "", d = e.getValue(n);
  return {
    nestingLevel: o,
    groupByColumn: n,
    groupValue: d
  };
}, v = (e, o, n = []) => {
  o((d) => {
    const r = d.filter((t) => n.includes(t.id)), i = d.filter((t) => !n.includes(t.id));
    if (n.includes(e))
      return d;
    const a = i.findIndex((t) => t.id === e);
    if (a !== -1) {
      const c = !i[a].desc, s = [{
        id: e,
        desc: c
      }];
      return [...r, ...s];
    } else {
      const t = [{
        id: e,
        desc: !1
      }];
      return [...r, ...t];
    }
  });
};
function w(e, o, n) {
  if (o <= 0)
    return null;
  const r = e.getPrePaginationRowModel().rows;
  if (r.length === 0)
    return null;
  let i = -1;
  const {
    selectedRowId: a,
    selectedRowIndex: t,
    data: c = []
  } = n;
  if (a != null)
    i = r.findIndex((s) => s.getIsGrouped() ? !1 : s.original.id === a);
  else if (typeof t == "number" && t >= 0 && t < c.length) {
    const s = c[t];
    s && (i = r.findIndex((g) => {
      if (g.getIsGrouped())
        return !1;
      if (g.original === s)
        return !0;
      const u = g.original;
      return s.id !== void 0 && u.id === s.id;
    }));
  }
  return i < 0 ? null : Math.floor(i / o);
}
const x = (e, o, n, d) => {
  const r = document.createElement("div");
  Object.assign(r.style, l.dragGhost);
  const i = document.createElement("div");
  Object.assign(i.style, l.dragGhostText), i.innerText = n > 1 ? `${o} + ${n} ${d}` : o, document.body.appendChild(i);
  const a = Math.max(i.offsetWidth);
  document.body.removeChild(i);
  const t = document.createElement("div");
  if (Object.assign(t.style, {
    ...l.dragGhostStackContainer,
    width: `${a}px`
  }), n > 1)
    for (let h = n > 3 ? 3 : n; h > 0; h--) {
      const p = document.createElement("div");
      Object.assign(p.style, {
        ...l.dragGhostCard,
        top: `${h * 4}px`,
        left: `${h * 4}px`,
        zIndex: `${10 - h}`,
        width: "100%"
      }), t.appendChild(p);
    }
  const c = document.createElement("div");
  Object.assign(c.style, {
    ...l.dragGhostCard,
    ...l.dragGhostTopCard,
    top: "0",
    left: "0",
    zIndex: "10"
  });
  const s = document.createElement("div");
  Object.assign(s.style, l.dragGhostRow), s.innerHTML = `<span>${n > 1 ? `${o} + ${n - 1} ${d}` : o}</span>`;
  const g = document.createElement("div");
  Object.assign(g.style, l.dragGhostIconContainer), g.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#1C5A4A">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
        </svg>
    `, c.appendChild(s), t.appendChild(c), t.appendChild(g), r.appendChild(t), document.body.appendChild(r), e.dataTransfer.setDragImage(r, 20, 20), setTimeout(() => {
    document.body.removeChild(r);
  }, 0);
  const u = () => {
    e.currentTarget.style.opacity = "", e.currentTarget.style.background = "", e.currentTarget.removeEventListener("dragend", u);
  };
  e.currentTarget.addEventListener("dragend", u);
}, y = (e) => {
  const o = {};
  return e.getHeaderGroups().forEach((n) => {
    n.headers.forEach((d) => {
      if (d.id !== "expander" && !d.column.getIsGrouped()) {
        const r = document.querySelector(`[id="${d.id}"]`);
        r && (o[d.id] = r.getBoundingClientRect().width);
      }
    });
  }), o;
};
export {
  x as createDragGhost,
  m as formatColumnName,
  C as getGroupDetails,
  y as getHeaderWidths,
  w as getSelectedRowPageFromTable,
  v as handleSortingChange
};
